import OfflineSections from "./OfflineSections"

/* Protopia Ecosystem component */
export interface ILandingEditOverlayProps {
   
}
const LandingEditOverlay = (props: ILandingEditOverlayProps): JSX.Element => {
    return <div style={{ width:"100%", position: "absolute", top:0, left:0, zIndex:90}} > 
       <OfflineSections />
    </div>
}
export default LandingEditOverlay